// ABOUTME: Builds full load configuration from backend options DTO.
// Maps fullLoad sub-section of quantity constraints to FullLoadConfiguration.

import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {FullLoadConfiguration} from './types'

export const buildFullLoadConfiguration = ({
  options: {constraints}
}: BuildConfigurationInput): FullLoadConfiguration => {
  const fullLoads = constraints.quantity.fullLoads
  if (!fullLoads || !fullLoads.isEnabled) {
    return {fullLoad: {isEnabled: false}}
  }
  const options = fullLoads.values.map((v) => ({
    numberOfLoads: v.loads,
    minQuantity: v.minQuantity,
    maxQuantity: v.maxQuantity,
    uom: fullLoads.quantityUom
  }))

  const defaultOption = options.find((opt) => opt.numberOfLoads === fullLoads.default) ?? options[0]

  return {
    fullLoad: {
      isEnabled: true,
      defaultOption,
      options
    }
  }
}
